import React from 'react';

const About = () => (
    <div style={{width: '85vw', margin: '0 auto'}}>
        <h1 style={{color: '#dfae20', fontFamily: 'fantasy', fontSize: '50px'}} >About</h1>
        <h3 style={{color: '#dfae20', lineHeight: '1.5em', fontWeight: '250'}}>Adam's Sniper Bot Was Created With The Sole Purpose Of
            Providing A Clean Redefined Mobile Botting Solution For Users Who Want To Snipe BSC Launches On The Go.</h3>
        <h3 style={{color: '#dfae20', lineHeight: '1.5em', fontWeight: '250'}}>Using Pancakeswap Or Poocoin Will Never Get You A First Entry Into A Coin, No Matter The Slippage You Set. This Is Why Individuals Seek Bots In Order To Secure A Faster Entry Into A Launch.</h3>
        <h3 style={{color: '#dfae20', lineHeight: '1.5em', fontWeight: '250'}}>Most Bots However, Are Designed For Desktop Only. With Adams Sniper Bot, You Can Snipe On The Go Without Worrying When A Token Launches</h3>
        <h3 style={{color: '#dfae20', lineHeight: '1.5em', fontWeight: '250'}}>Contact Adam Using The Info Below To Gain Entry Into The Bot.</h3>
    </div>
)

export default About;